import {Component, ElementRef, Input, Renderer2} from '@angular/core';
import { GlobalServiceProvider} from "../../../providers/global.service";
import { ApiServiceProvider} from "../../../providers/api.service";
import {Observable} from "rxjs/Observable";
import 'rxjs/add/observable/of';
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {CommandComponent} from "../command-component";

/**
 * Generated class for the ParticipantListCmdComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */

declare var window;

@Component({
  selector: 'participant-detail-cmd',
  templateUrl: 'participant-detail-cmd.html'
  // template:'<div *ngFor="let c of participants" (click)="clicked(c)">{{c.username}}</div>'
})


export class ParticipantDetailCmdComponent implements CommandComponent{

  text: string;
  @Input() public participant: Object;



  public static count=0;
  public _count;


  public participantForm: FormGroup;

  constructor(
              public global: GlobalServiceProvider,
              public api: ApiServiceProvider,
              private fb: FormBuilder,
              private renderer: Renderer2) {


  }


  getParticipantWithUsername(username){
    this.participant= this.global.participantsByUsername[username]
  }

  ngOnInit(){

  }







  public clicked(c)
  {
    console.log("clicked", c);

  }




  makeEditable(participant){
    let formObj: Array<FormControl> = [];

  }


  save(p){
    this.participant = p;
    let result =  this.global.createParticipant(p);
    return result;
  }


  public setData(p){
    debugger;
    this.participant = p
  }
}



// WEBPACK FOOTER //
// ./src/components/commands/participant-detail-cmd/participant-detail-cmd.ts